var _style, _line, _defs, _g, _rect, _rect2, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 311 170.6",
    style: {
      enableBackground: "new 0 0 311 170.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#6DB6B0;stroke-width:2.1344;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000149374676457920199400000013252575007766343056_);fill:none;stroke:#7FCDC4;stroke-width:4.2687;stroke-miterlimit:5;}\n\t.st2{fill:#CEDC28;}\n\t.st3{fill:none;}\n\t.st4{enable-background:new    ;}\n\t.st5{clip-path:url(#SVGID_00000088827982198971703850000006189276980204024758_);}\n\t.st6{clip-path:url(#SVGID_00000054968436113743292370000004686240915368665256_);}\n\t.st7{clip-path:url(#SVGID_00000036230289175152219490000005214220452854026374_);fill:#55BBB1;}\n\t.st8{clip-path:url(#SVGID_00000162338324302152242160000017018882031902737044_);}\n\t.st9{clip-path:url(#SVGID_00000125570239621207179020000014677100125354078125_);}\n\t.st10{clip-path:url(#SVGID_00000010991785464043670510000013621620820787936132_);fill:#55BBB1;}\n\t.st11{clip-path:url(#SVGID_00000098183584352894143880000004544497663595959961_);}\n\t.st12{clip-path:url(#SVGID_00000017488049108963047220000010272941235341319075_);}\n\t.st13{clip-path:url(#SVGID_00000008121766387866678900000011526868182212455322_);fill:#55BBB1;}\n\t.st14{clip-path:url(#SVGID_00000014601185912116144420000008883296500819532465_);}\n\t.st15{clip-path:url(#SVGID_00000173874869309004804920000008660312864151394433_);}\n\t.st16{clip-path:url(#SVGID_00000021081008630996394340000011369960665737687229_);fill:#55BBB1;}\n\t.st17{clip-path:url(#SVGID_00000095321861171246744300000000966370652708353921_);}\n\t.st18{clip-path:url(#SVGID_00000037662309222164764460000004884309962347391916_);}\n\t.st19{clip-path:url(#SVGID_00000002369347516268136330000010739745004132515729_);fill:#55BBB1;}\n\t.st20{clip-path:url(#SVGID_00000160151663205879663210000003041747874991270320_);}\n\t.st21{clip-path:url(#SVGID_00000070103191167285212860000005914793301008573836_);}\n\t.st22{clip-path:url(#SVGID_00000169533034466846672610000012095837859987975067_);fill:#55BBB1;}\n\t.st23{clip-path:url(#SVGID_00000018944461160211010080000003422653503634167438_);}\n\t.st24{clip-path:url(#SVGID_00000062176103464794347050000018291727190417983874_);}\n\t.st25{clip-path:url(#SVGID_00000178910782296886667210000012939988684012320670_);fill:#55BBB1;}\n\t.st26{clip-path:url(#SVGID_00000137091312380411641070000005321781626085780611_);}\n\t.st27{clip-path:url(#SVGID_00000005245287239557722300000001670805963816786820_);}\n\t.st28{clip-path:url(#SVGID_00000156574831307909320730000000800550079305489832_);fill:#55BBB1;}\n\t.st29{clip-path:url(#SVGID_00000062186235553304989570000002376008290150734781_);}\n\t.st30{clip-path:url(#SVGID_00000072250355693503212600000015186810849409186739_);}\n\t.st31{clip-path:url(#SVGID_00000078741644586129972320000007702891238272770691_);fill:#55BBB1;}\n\t.st32{clip-path:url(#SVGID_00000115493753915536072500000017545777580700614577_);}\n\t.st33{clip-path:url(#SVGID_00000007386372217233878600000001919767013553511045_);}\n\t.st34{clip-path:url(#SVGID_00000093881687296344170690000003786405771926320015_);fill:#55BBB1;}\n\t.st35{clip-path:url(#SVGID_00000047748170103407578590000009221151507085218972_);}\n\t.st36{clip-path:url(#SVGID_00000037682848076428964980000008169450308270315655_);}\n\t.st37{clip-path:url(#SVGID_00000031926121758712663350000008369381582446489004_);fill:#55BBB1;}\n\t.st38{clip-path:url(#SVGID_00000132769165925958548840000010642716234966804379_);}\n\t.st39{clip-path:url(#SVGID_00000068639987911311412090000012549651672737143446_);}\n\t.st40{clip-path:url(#SVGID_00000149361055231340336460000017044994326559541435_);fill:#55BBB1;}\n\t.st41{clip-path:url(#SVGID_00000042007702041513648520000017673523173918020768_);}\n\t.st42{clip-path:url(#SVGID_00000055704130894610685250000012739430811849793976_);}\n\t.st43{clip-path:url(#SVGID_00000085232652380079022970000005361789270046077569_);fill:#55BBB1;}\n\t.st44{clip-path:url(#SVGID_00000128446109105462065230000002881667203029120914_);}\n\t.st45{clip-path:url(#SVGID_00000053519952666549574620000016592427475981888178_);}\n\t.st46{clip-path:url(#SVGID_00000155826638131061658520000001346357970576079499_);fill:#55BBB1;}\n\t.st47{clip-path:url(#SVGID_00000112603222375814568230000013317386931993832619_);}\n\t.st48{clip-path:url(#SVGID_00000050649332239993506680000006685196061875062716_);}\n\t.st49{clip-path:url(#SVGID_00000062895656096603009270000016008555562190377363_);fill:#55BBB1;}\n\t.st50{clip-path:url(#SVGID_00000145019401166390165570000015034907605346513313_);}\n\t.st51{clip-path:url(#SVGID_00000083796657597489598240000011064480367981590711_);}\n\t.st52{clip-path:url(#SVGID_00000173857302432968829550000007534326902421698948_);fill:#55BBB1;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 118.4,
    y1: 116.1,
    x2: 84.3,
    y2: 115.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M137.8,97.1h138c11,0,20,9,20,20s-9,20-20,20h-138c-11,0-20-9-20-20S126.8,97.1,137.8,97.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011718428810396960820000014604732919294298046_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011718428810396960820000014604732919294298046_)",
      fill: "none",
      stroke: "#7FCDC4",
      strokeWidth: 4.2687,
      strokeMiterlimit: 5
    },
    d: " M137.8,97.1h138c11,0,20,9,20,20s-9,20-20,20h-138c-11,0-20-9-20-20S126.8,97.1,137.8,97.1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.5,108.7c0.1-0.1,0.1-0.1,0.2-0.1h2.8c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v16 c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1h-2.7c-0.2,0-0.3-0.1-0.3-0.2l-6.1-10.1l-0.1-0.1c0,0,0,0,0,0.1v10c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1h-2.8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1 h2.7c0.2,0,0.3,0.1,0.3,0.2l6.1,10.1l0.1,0.1c0,0,0,0,0-0.1V109C145.4,108.8,145.4,108.7,145.5,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157,124.7c-0.9-0.5-1.7-1.2-2.2-2.1s-0.8-1.9-0.8-3.1v-5.1c0-1.2,0.3-2.2,0.8-3.1s1.2-1.6,2.2-2.1 s2-0.7,3.2-0.7s2.3,0.2,3.3,0.7c0.9,0.5,1.7,1.2,2.2,2.1s0.8,1.9,0.8,3.1v5.1c0,1.2-0.3,2.2-0.8,3.1s-1.2,1.6-2.2,2.1 c-0.9,0.5-2,0.7-3.3,0.7C159,125.4,157.9,125.2,157,124.7z M162.4,121.7c0.5-0.6,0.8-1.3,0.8-2.2v-5.2c0-0.9-0.3-1.6-0.8-2.2 s-1.2-0.8-2.1-0.8c-0.9,0-1.6,0.3-2.1,0.8c-0.5,0.6-0.8,1.3-0.8,2.2v5.2c0,0.9,0.3,1.6,0.8,2.2s1.2,0.8,2.1,0.8 C161.1,122.5,161.8,122.3,162.4,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.2,108.7c0.1,0.1,0.1,0.1,0.1,0.2v2.3c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1h-4.2c-0.1,0-0.1,0-0.1,0.1 v13.3c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1h-2.8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-13.3c0-0.1,0-0.1-0.1-0.1h-4.1 c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-2.3c0-0.1,0-0.1,0.1-0.2s0.1-0.1,0.2-0.1H183 C183.1,108.6,183.2,108.6,183.2,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.1,111.4c-0.1,0.1-0.1,0.1-0.2,0.1h-7.7c-0.1,0-0.1,0-0.1,0.1v3.7c0,0.1,0,0.1,0.1,0.1h5.1 c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v2.3c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1h-5.1c-0.1,0-0.1,0-0.1,0.1v6.5 c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1H196c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2 s0.1-0.1,0.2-0.1h10.9c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v2.3C207.2,111.3,207.1,111.3,207.1,111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.3,124.7c-0.9-0.5-1.7-1.2-2.2-2.1s-0.8-1.9-0.8-3.1v-5.1c0-1.2,0.3-2.2,0.8-3.1s1.2-1.6,2.2-2.1 c0.9-0.5,2-0.7,3.2-0.7s2.3,0.2,3.3,0.7s1.7,1.2,2.2,2.1s0.8,1.9,0.8,3.1v5.1c0,1.2-0.3,2.2-0.8,3.1s-1.2,1.6-2.2,2.1 s-2,0.7-3.3,0.7C216.3,125.4,215.2,125.2,214.3,124.7z M219.7,121.7c0.5-0.6,0.8-1.3,0.8-2.2v-5.2c0-0.9-0.3-1.6-0.8-2.2 s-1.2-0.8-2.1-0.8c-0.9,0-1.6,0.3-2.1,0.8c-0.5,0.6-0.8,1.3-0.8,2.2v5.2c0,0.9,0.3,1.6,0.8,2.2s1.2,0.8,2.1,0.8 S219.1,122.3,219.7,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.9,124.6c-0.9-0.5-1.6-1.1-2.2-2c-0.5-0.9-0.8-1.8-0.8-3v-10.7c0-0.1,0-0.1,0.1-0.2s0.1-0.1,0.2-0.1h2.8 c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v10.8c0,0.8,0.3,1.5,0.8,2s1.2,0.8,2,0.8s1.5-0.3,2-0.8s0.8-1.2,0.8-2v-10.8 c0-0.1,0-0.1,0.1-0.2s0.1-0.1,0.2-0.1h2.8c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v10.8c0,1.1-0.3,2.1-0.8,3s-1.2,1.5-2.2,2 c-0.9,0.5-2,0.7-3.2,0.7C233.9,125.3,232.8,125.1,231.9,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.3,108.7c0.1-0.1,0.1-0.1,0.2-0.1h2.8c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v16 c0,0.1,0,0.1-0.1,0.2s-0.1,0.1-0.2,0.1h-2.7c-0.2,0-0.3-0.1-0.3-0.2l-6.1-10.1l-0.1-0.1c0,0,0,0,0,0.1v10c0,0.1,0,0.1-0.1,0.2 s-0.1,0.1-0.2,0.1H247c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2s0.1-0.1,0.2-0.1h2.7 c0.2,0,0.3,0.1,0.3,0.2l6.1,10.1l0.1,0.1c0,0,0,0,0-0.1V109C256.2,108.8,256.3,108.7,256.3,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M265.2,125.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1h5.9 c1.2,0,2.2,0.2,3.1,0.6s1.6,1,2.1,1.8s0.7,1.6,0.7,2.6v6.5c0,1-0.2,1.9-0.7,2.6s-1.2,1.3-2.1,1.8c-0.9,0.4-1.9,0.6-3.1,0.6h-5.9 C265.3,125.1,265.2,125.1,265.2,125.1z M268.5,122.3h2.9c0.7,0,1.3-0.2,1.8-0.7c0.4-0.5,0.7-1.1,0.7-2v-5.4c0-0.8-0.2-1.5-0.7-2 c-0.4-0.5-1.1-0.7-1.8-0.7h-2.8c-0.1,0-0.1,0-0.1,0.1V122.3C268.4,122.3,268.5,122.3,268.5,122.3z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.8,
    y: 101.1,
    className: "st3",
    width: 178,
    height: 36
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 161,
    height: 160,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKEAAACgCAYAAABkDQwTAAAACXBIWXMAAAsSAAALEgHS3X78AAAU OElEQVR4nO1dS5LrOA5EvZg79aLvNIfpO/WiL1U1iw7VsGBkIgGStqWnjHBY4l9kMgFSsmx248aL 8fHqBtxYi//+8zcd07/++PPrWW1RcZPwhMiINoNXkPQm4Qmwk3QMzyLkTcI3xyQBj7xTZNpNxpuE b4oC+WbHUCLYTiLeJHxDCARk8cqYIkKlRNtBxpuEb4Qm+VAeH87IE8XB9KuJeJPwxRDNrk+TnVfg CZWd/8AKQt4kfCKKi4wq8apjmalfSR1HVIl5k3Aznki8WRKy862EvEm4CZOrW0YuFLeKhFXzPE3G m4Qb0PTzfBgi3yoSmsVqhxRwmoyIiDcJF2PBCjcj37OUcAsZIyLeJFyIBgE75KuQcAxjfp2qiCox UZiZPRLxF0p4YzkYyTyZ2CdK8ys4j8JQmSwuqs+3219DdL3f8JP1PyjhjRoSFVTUq6J8LE1Uttm/ yhQRRd1OOfKP32M9Plwu/1bC/VBIp3x+ge8oXRQXhXfqj1Qxup7omr8xTtpbCfeCqVgU5slR+fbH WZsi5bIhzMdFSmpB/KiQ0fEDbhIuADDFCgEZsTJl6ZLQ7CehEOnMxbNykKmWcJNwD6oEVBVRUVO1 fdV7vmOeSBUzQsI6p0l4tUfNnwBGwAohjYStaGOn70tE/O8/f3/89cefX2USPvNR87GukxJSNbOR s1/xE/3xLA7yKCbaq2K0Ol7jE06QL3NmS/WfgIwqYTICriDfuAhBcQzZYoSlk8dJIuHGR83LDT8R GSMwsmUqacG3gfOoXgSVaFker4BjOrpwSfcJxVtRY0ex+KjDK2VV2vUKMOXy18X6RVFHI/GdcrMy ojao40pBlXDx4+ZKfjSbroRs4DJTjMKOc686Zli5orGqKKNi5lOfECqhcBuKdZwPU9UQhXXa+BSQ NjBzitJXlQel8XUpVgeVHV2DOp5RnQ/o3LZjJGGNyYgXlYPq/MY7EFGEOojKwGfxlU9UFmuvgTxs zFFfmBkwx8LsZsfR+RjGnNqP4Fy69fNGUCdF1n+Ksq2YgFEf+++oLjRGURqf7gcq+4QKAVHn+DSM TJEvQ4m4Ww0nVuIr1C769sf+HLUXpYn6OyJilNbnK+OBhIX7oONxpbOOMPQgJJuZLO82RH0SEDO7 5pXILI9Sv7c6RxgjIhqHMd6XidJ+Y+a2neJP+GNWVkbKLhGrhJDKXfSOmEwl2Tc6Zu2PlDBSutkH E5hZfoBCwkz5VDJG5c7eEDeLZ90MSh3YqLviz6kK11Hhrin1RK7mfUjb8Qkzfwal9VBmWcVHydpd ASp/1g2oEoTly/o428NTXJ5sfDoq+YCMhOrMi0jY9ZFmb4grbUb1RmmVDXREEt8vq6BMcmVyMiJm eVB9ZTKqSoj8EebPZGaHXVC2jRMRVTVdCKy+8Xxsg1JOtw2qb4gme+WOyTaVU9BZmDDSofOsPGSK UTpmkmfJGO15RQM2S3IfVymvqoQoPppomelV2lYibXefMAqPCFjxVzJkm6eoXUpaX8d4fuTPVuar Te5YJlO9zOIoyFbKW8FIqJhTpoCMhOPFRabCjCuSsg3RIaGvPzJnmRnbDUTEjuKjyZWRcSk5f5Cw +dgW8g1Vk/xhZp+GTSxamIxxqxQi6tyIgEiNV6hSZnHY8RiWkUQlYBXbFiYIChl9Op//y/59kOJz +O7UP55XBsxszjHPCDkLlZTV+tFk7hJw2xbNAeb4ZsqI8pv97AivclWgQckGB/mByh6lzxupMLse hWAsvGOGx7zKdgyyDhFaROwqISJlJfzAl5Cm0iZEQGVgvTqgQWADWPVJq9fNBKGLV/q47S0af6ya ZYQZBfTtQD7hjHk6vhUyMldgxWTLoJSfLTKqZllNG6arkjC7wIpfstpnUogY1c2c8+5+WVWBq1hV 5owPaIb7aNs+YRUZETL1Q5vRrJ4KEX3+yPR6MlYHTfVLWV6Ufpc/OEPMsa++3GdM8wM7SBh1DupE Zb+vUl9GxKwctAiJlBE57OjaO6SpKOpuM+/hibV9dbwKyAzOlucHuro4QT7gTJuysFVlr8SseVbx o44fP3QSHmNXGpitGsdzRB5Epg/7/3v2lLeT+ngWp77Tz4ehYzQZfLjviy5myVOpn5pXIc8PqEqo 3MLqAs0+RbUO/HJhTA277cni1LL9eea6VMmhpO8uJhSRQr7gAw7RYyT0/lFWeeRTRfAERmY52siO 0ik+YZSvioiAyC/0afyx4t+pbUeb7buAVFDZwF6yRTMW1hlU37ErVJWRMPqulKvcUYiOzfD1MP+1 iopQoPzsfAxnaaeIP7MwWWmKo4FTTR/zvaJvBKbmvi1K21h9yAzPmN5oPNA2V4VAmemeVsOMhB1T XIWaF5nD4xs5+mqbKumirZuKv4ja7cNU/26cxCwdCkP7e1k50bG8P3hgdosmIqBKSubnjeUgszfm q6gfqsu3K/pGRPNpM0Tt7Kjg7HbSUVZ0fJxHpJIJpqBKQkaaI17pTD8InmSZmUHloLDo3MdlRPRt YYQ0EBe1paPaI1b4g/5Y9Q2RgpYI2tmi8eerfEOlrCieEXG2TR2FNzFNx3dF/d5VIka+TAWRKqKy f4SNe9IVJewQJELU2V5hq8RWfacZRE7/aKKZ25CV151IaOERxWflZKY2U8GsfRAPr4YrvPyHyXYG 5IxHPtKH8PHl7ITaxuwOTlQGq+8AUx5kEhEiVYvqQSqI4kq8eOa9Y2WRgBQwUspqGTNQXBFUL1NF lXgRMv98TKPEIzIh4lWITtvyLBKqMz9bkCgdP6bbgYrLoLbXl11B5VqZ76aQkC1EmKr+gLe26qvh FHR8OGWVzchYRVWRGNQV/AwUP6+zOPFpVXKpChgRG2Lmx+/V1d9xrKwCmbnzYQxs5o91RelWL4wU KIs/JUyJG+PRwmQ1OUPM/NouCmfnyvGByAdEq9AxPZp5lYHyZaq+bASm9JX0Kio+2niMSIfyZP5i 9G1m8cK3+xsTRiJl0JRwpE6eiB4KERHBfLkR4VF7GRDRWRoWX1WcrC8qyre8fZ1Xw+3eAhnr+QqO EaJZzGboccyucZWvpyjnjIuhplVUsGp+kXrKba2+BgSB7dcpKrhq4THmzb7H9Koir9hS8ekVH1Xt D8VnRJOxS0JW7g+gPeiVrwE5zjOzVXX4MzVkHWjBtz9GJtgvglgbFSDiRdfFrjU6ZulYvhkVzNoh C8nMW7l8ui6qG7wZGAH9d7banrk2pu7R4meVmUXhq0yxuTSovB9gd+I6b2odP+bCo/Q+7FlQOggp ENsWUqBOLFXpo/NKWnSMiOfPkenO2iNhxUsyUZoZ0imE6ZTTLQORs4pIcVUVVPwvhYTsmxEQhaF6 vpE9j4BIOGOKq35id0BnMKoPS7OrXV13Q1EghXg+rKqMWX3fUB6IWflnOjMqmDV0xl+KMEOCVcSs tCEa+Iq/h9JlZpYRMFNhGdU/04nO1bgqmM+DTIlqdtsdBspasThTfTzVHFaIqaqiUt431McCq381 6830zMqZNbDiy6iokjorJ1MVBRXyIuVR/bhPEqeoIKo3ROVPKSur485sj1RiDFMUS53ZUWdGdUTn 0d4gahtKg1a6nYmYmdCKGlYmNCIhyu+PW1D2CVfAD5aanhGqo1r+O9uKUTqYTSi0LePTZ6bY9wMK Z+RRyKRYhpSA1b/mfcZDrZka+vDxuDLbM4VAg8jaUX3QQNlfrAxQpNrZtaqk9McvIaDZ818NZ5ab u4rJGPOgDu+2z7dnRLayjUw2sgDZZPHXZvZ4rYo5rZIwa9MDun9OvouETAHYHQhGOHVGprMV1B1h bCdqfxQeKSG6ZlQvM7+MhF1FQ/2o9GebgGbr3sAQnSsKwPwp1rHseESkREjZomPUVuQ/Zrf4kMoq KsgsgE+bld2ZxFsIaFb/3bEZ93WYcx8pAiMfilfTHFAnRXW7RCWcYt59PhTmSclIaEG8UkcUv42A Ztr7CdHx+M0UEZWJ6hy/UZiPG8HcABUdQvrjGahmVzHFlf5T+9jM1hDQbK1P6MnICIKUVK2ngl33 fxn5KmRkJDnCVbPMSJjVoYR9YxUBzfa9lctMM1Mo3izuvIoZ3gFGNtQXbIUcKVFEuDFtVxGja4nw NPIdUEjI1C1bKUZQVsfjedahmZJ07/RkcZkJrqg98+fUDyuH1Z3FfWMHAc3mX4g0znREQLRIyTol m71Kh3RNcdS+SAXHtN2tGUS+6FxRwOUWZBf5DiASRp2JEA2AWayelc3b8RipHzr35Vf9swoQAaMJ l23PdD4+b1R269p2k+9A9f2EmR+hXDS6n5rlVczKWF50zNowps2ut4LIXTF3XiWcL4MRUL6GZ5HO Y9XqOBo0dkHIlxyPq6RjpEJE9EAmNgOyHIp1QIqWhTOChm1+FckyVP7HRFVDtkWjopPXkyoiYOYC ZHdFVKB86mSLCObT+jjUDjN7XwKazf+FhJlmwjITnN1RqHagJ2BGJHb7rWr+PVj+qtpFxJs2w69G 9t92ygUqnfZJ0vrwqH6vZh/uOPv4vFka/62Wr6JCuA4hT4XOFg1TiGzWR9s3EdEioK0f5u91VsgK kNpX8qGJmE3YqP5Tk7G6Wa2kRfg0rByIjGzPUQnbRcIqmF83Hh/nnxaT0OeJvh/wzv6gWe9/TKr+ kgq0uauQZ2ZRgspD11aZlEd6f9z1BTMi+uNTQH17P+rI43vWp0Gdy6D6g10fcoUviMwv67vIHKPy UNip0L1tt1oR2R5blNYfqyY5awOr18dF7UVA6lWZlOiY1v/uptgM/O6YNDybiWOc2smogz0ilTJ7 JOWMAqJ8Wfm+HSOYOa5aidOrXoTOPiFSg7FTUNiXy2MuXcX/QwRACpiVrbZhTIesQ5RnFQFR+Q84 gwqaJR2evLnVDzZSHTP+z0aZamV1RddRNcUeyoAzhYvCZj6obNTG0xDQLHkNSHIhUWcf34r5RZ2N oBARmekqskmilo+uzZMo64+M8D9wJgKaFQaKqKKqiJXPqJy+rKxOBJU0Wbgy+fz5+DlWv9leYKau Dzgb+Q7IL0QSFivMF1LVLspXQabcM0o8i8yvQ3mi4weclYBmxbdyiReadbTqbKN8WfqVhFpRllIG u7bs/NQENKu/Gk71EytQiVXNq/qhFWVEhIjCM/JFeVN/z+PsBDRrkNCMPm0zi0o5nYHvgi0UWBhK UzXLl0aLhC+GMgF2muPVluC3xyoSrtgWQXjXge20q7PNc3m0SDjx92MR0C2yCDPmugpVYbv1RNfN 9iUvix2vhss6tNLRX0NcdIwIEN027CAj3Urfjl3PGJ+lOx1WkFCdsatm9DgQnmyIfGrdK1boCkFU Il2OcBF2LUzUOxcsHVMctJWBVsidLRk1zrc1Oj+QWYXISpiRflrsGr0Eq82x77jsIQV/rEBRwjFs BZhZzrZuzNa5B5c0yWUSupm30nn2BIr8v+5gVkmuhitqnbUpm0xKWafGSiVkCxKznvqhWV8lIxpc H5/lz+KY24AwXh+7rkup34hnvL1f9m8cPAFnVsMqaSt3PVBYRQE7uJxJXrk63p13ZjXcHawKaSt3 Vg5EKnjkja7hMsQbseJfPsfjbG+Q5Y3gByM6j8rpbtFEebPwLO6ov+JaXJJsCLvvHfvBZytklJ6d K/WvyqNuO6Ew5B93cPptmRGv+Ecnj4iACvmqpKgCKZQHcw2Y+5C1EZnky2GWhMwkj8fs4/Oi8qNz NW4G1UVP5BaoK2Bf7iVJ57HaHHdWwRER2faOTxOZNoX86gRRylTaXXVNEB7iz37X5FXPE6KBRunQ OcqzCqrvpip45np0/NfTYwUJVVKwAe36hT5+t0mupLkXHiKetTBRZntFHSqkQHcfUByKR3VWFiKV vb4o/SX9xHd4vJ8pSIeAs4q4wvx3lPO3xTuQsIJV/mD0eNYYV4VKxI6L0Yk7Fd6ZhNUB2jkos4S6 DGF24J1J6BGZ6Z2LEdaO9naKw4oHKk6PZ5FQ7Uy2pxYds7Au2MIpq3v3hKg8rXMarCBh9Zm+mQdS O4NcydMlUaeNqgpehmwIz1DCHbNX3ezeBXR3ZBa/DfFGvMonRMTMnkCuhCtlzqTtAD0Qy340dXms JuFX8MnSojgWNg7Y6kGrPF1ddUXYsYrLkXT2jol/2jlSpeyuxJhmvEuQ1VF5yLS6MKreKekcqxOU TehLEPKVzxOi213+NpXZI0n9sVLHTJsiRPVnao3IhazHJUiWYfX/HR/HGbL7qD6ckXE1EZXrYPX7 8ChdptS/1f7haiVEJhml69ygZ2l2mqzIfYjOkdllCujDo3RRvWZ2/hdlzv7fceTDjfEddJ4UqfiH SlnserJrRcqnmOEdC623x0olRP6cWa1jIxJUzX21TqUNSrnMNDOFi8pB/uHlSLrDJxzDDqjq5svx 5OvuCaoDhyZO5y4I8w0VZYzKRHWdGiu3aMbzSLkQERmBUVlZmyrhB9RFUqX+zCSPxxH52OLmMthl jtFiI1tUIB9z1rRW03VdCVQeUsPxOIpTyj49VpBQ8Z86+3vIv2R5OnEjlL3BSjsiHxERkYWxNp0e rZvuwU8M0bN+Yxh6BhA9CLD64QRlEHfWmfmIWZqozNNvz5jt26xWfbkjHcpvNkeM6gB1FiNKvYxM yAyfnlwqdviE4zEjV6WsESv3JLM2RKhs3bAwVe0uT8yd947ZAmW23FdiRl2ZEqrhl8OqvxU7wDou 2n5gH+WvWN/58yleg++TrB8vhx1K6H25SAnVfb/RLJ8NVfOsnn/jCosSs8kBFl7Ek/0wSGnDlUjI 4krqdxUCmk0+WS10hDc5URgyTyj+LB92DVG4T//bYInKFF5N1v2dSAWv2F9cVZ5U15VU0GzhgDXe kXdWM7sSJTJdjXwHthBhw0sbz0bYpWS5KvkOPGVwz/4m0Wfi6oS7cePGjRsR/geD0t27aop5/AAA AABJRU5ErkJggg==",
    transform: "matrix(0.9937 0 0 0.9937 12.8031 9.1482)"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 9.1,
    className: "st3",
    width: 160,
    height: 159
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003826867169867744400000013233882600246934400_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033359630521967560370000013959586900056787095_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003826867169867744400000013233882600246934400_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000033359630521967560370000013959586900056787095_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155116845746919258160000017199810989861329063_",
    d: "M114.1,38.7v10.8c0,12.3,7.2,23.8,18.9,30.1 c11.7-6.3,18.9-17.7,18.9-30.1V38.7c-3.5,0.1-7-0.6-10.3-2s-6.2-3.4-8.7-5.9c-2.5,2.5-5.4,4.5-8.7,5.9 C121.1,38.1,117.6,38.8,114.1,38.7L114.1,38.7z M133,83.6c-0.3,0-0.6-0.1-0.9-0.2c-13.5-6.9-21.9-19.8-21.9-33.9V36.9 c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6c6.6,0,13.5-1,19.4-8.1c0.4-0.4,0.9-0.7,1.5-0.7s1.1,0.3,1.5,0.7 c5.9,7.2,12.8,8.1,19.4,8.1l0,0c0.5,0,1,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.3v12.6c0,14.1-8.4,27-21.9,33.9 C133.6,83.5,133.3,83.6,133,83.6L133,83.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052827060512813525250000014400661462500496831_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155116845746919258160000017199810989861329063_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052827060512813525250000014400661462500496831_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047053122564036319310000012903237886101798070_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156581408006620784320000004560780909903163570_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047053122564036319310000012903237886101798070_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 109.3,
    y: 25.1,
    style: {
      clipPath: "url(#SVGID_00000156581408006620784320000004560780909903163570_)",
      fill: "#55BBB1"
    },
    width: 47.5,
    height: 59.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000087380668546572972980000004798975182694574999_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114781429203970635280000010580340381838167728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087380668546572972980000004798975182694574999_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114781429203970635280000010580340381838167728_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070819273652863313050000007215914791569332397_",
    d: "M50.8,70.7c-0.7,0-1.5,0.3-2,0.8s-0.8,1.2-0.8,2 v31.4c0,0.8,0.3,1.5,0.8,2s1.3,0.8,2,0.8h48.3c0.8,0,1.5-0.3,2-0.8s0.8-1.3,0.8-2V73.5c0-0.8-0.3-1.5-0.8-2s-1.3-0.8-2-0.8 H50.8z M99.1,111.5H50.8c-1.8,0-3.4-0.7-4.7-1.9c-1.2-1.2-1.9-2.9-1.9-4.7V73.5c0-1.8,0.7-3.4,1.9-4.7 c1.2-1.2,2.9-1.9,4.7-1.9h48.3c1.8,0,3.4,0.7,4.7,1.9c1.2,1.2,1.9,2.9,1.9,4.7v31.4c0,1.8-0.7,3.4-1.9,4.7 C102.6,110.8,100.9,111.5,99.1,111.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101814650242643462190000005881764929106643631_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070819273652863313050000007215914791569332397_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101814650242643462190000005881764929106643631_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016757981093452279240000004003918981308370830_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061441623174970997910000013083346402602463921_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016757981093452279240000004003918981308370830_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 65.9,
    style: {
      clipPath: "url(#SVGID_00000061441623174970997910000013083346402602463921_)",
      fill: "#55BBB1"
    },
    width: 63.6,
    height: 46.6
  })))))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155126796280373949610000014445180626474909845_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181054613422532872510000003953341526512558524_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155126796280373949610000014445180626474909845_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181054613422532872510000003953341526512558524_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000063631185311223062650000003108408585734280852_",
    d: "M44.2,79.6c-3.4,0-6.6,1.8-8.3,4.8 c-1.7,3-1.7,6.6,0,9.6s4.9,4.8,8.3,4.8V79.6z M46.1,102.6h-1.9c-4.8,0-9.2-2.5-11.6-6.7c-2.4-4.1-2.4-9.2,0-13.4 c2.4-4.1,6.8-6.7,11.6-6.7h1.9c0.5,0,1,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.3v22.9c0,0.5-0.2,1-0.6,1.3 C47,102.4,46.6,102.6,46.1,102.6L46.1,102.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015318732284569392110000006787350328718889657_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063631185311223062650000003108408585734280852_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015318732284569392110000006787350328718889657_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145765908318793426890000002131723030133208718_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016780004172430999030000010835361042957160340_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145765908318793426890000002131723030133208718_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 74.8,
    style: {
      clipPath: "url(#SVGID_00000016780004172430999030000010835361042957160340_)",
      fill: "#55BBB1"
    },
    width: 19.8,
    height: 28.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165230341071432701630000010625636573612348048_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092418162521660565980000001261063787113205156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165230341071432701630000010625636573612348048_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092418162521660565980000001261063787113205156_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034057675691856031040000006802742885337931671_",
    d: "M105.8,98.8L105.8,98.8L105.8,98.8 c3.5,0,6.7-1.8,8.4-4.8c1.7-3,1.7-6.6,0-9.6s-4.9-4.8-8.3-4.8h-0.1V98.8z M105.9,102.6h-2c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-23c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6h2c4.8,0,9.2,2.5,11.6,6.7c2.4,4.1,2.4,9.2,0,13.4 C115,100,110.6,102.6,105.9,102.6L105.9,102.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036214783179905150040000004928000912772447126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034057675691856031040000006802742885337931671_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036214783179905150040000004928000912772447126_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016076174853088194690000016906031781214284963_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032649661137857424290000017233860911533828520_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016076174853088194690000016906031781214284963_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 74.9,
    style: {
      clipPath: "url(#SVGID_00000032649661137857424290000017233860911533828520_)",
      fill: "#55BBB1"
    },
    width: 19.9,
    height: 28.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000126293374731132292020000001340734897810676886_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174592375875368800160000004771709688628134574_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126293374731132292020000001340734897810676886_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000174592375875368800160000004771709688628134574_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000117653914631901630120000004337788839039917960_",
    d: "M89.1,81.7c-0.8,0-1.5,0.3-2.1,0.9s-0.9,1.3-0.9,2.1 c0,0.8,0.3,1.5,0.9,2.1s1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9s0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1 C90.7,82,89.9,81.7,89.1,81.7L89.1,81.7z M89.1,91.4c-1.8,0-3.5-0.7-4.8-2c-1.3-1.3-2-3-2-4.8s0.7-3.5,2-4.8 c1.3-1.3,3-2,4.8-2s3.5,0.7,4.8,2c1.3,1.3,2,3,2,4.8c0,1.8-0.7,3.5-2,4.8C92.6,90.7,90.9,91.4,89.1,91.4L89.1,91.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049196514417407336840000009517866210187953071_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117653914631901630120000004337788839039917960_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049196514417407336840000009517866210187953071_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000170241040770774220250000018141524423094246292_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044162113123852434710000005563656747312405395_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170241040770774220250000018141524423094246292_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 76.9,
    style: {
      clipPath: "url(#SVGID_00000044162113123852434710000005563656747312405395_)",
      fill: "#55BBB1"
    },
    width: 15.5,
    height: 15.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016075681826238436850000013897434735001114250_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136390517115476817210000018097073209541332906_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016075681826238436850000013897434735001114250_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000136390517115476817210000018097073209541332906_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170987622779517962170000010207700240106911141_",
    d: "M60.8,81.7c-0.8,0-1.5,0.3-2.1,0.9s-0.9,1.3-0.9,2.1 c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9s1.5-0.3,2.1-0.9s0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1 C62.3,82,61.6,81.7,60.8,81.7L60.8,81.7z M60.8,91.4c-1.8,0-3.5-0.7-4.8-2s-2-3-2-4.8s0.7-3.5,2-4.8c1.3-1.3,3-2,4.8-2 s3.5,0.7,4.8,2c1.3,1.3,2,3,2,4.8c0,1.8-0.7,3.5-2,4.8C64.3,90.7,62.6,91.4,60.8,91.4L60.8,91.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117642286161238512730000005174267043701028272_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170987622779517962170000010207700240106911141_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000117642286161238512730000005174267043701028272_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106844223169333200060000008384323438405279112_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128474772748544458320000016269607117282688937_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106844223169333200060000008384323438405279112_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 76.9,
    style: {
      clipPath: "url(#SVGID_00000128474772748544458320000016269607117282688937_)",
      fill: "#55BBB1"
    },
    width: 15.5,
    height: 15.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000017517451982502160950000017673148520456464043_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109007674902459413360000006995944203201471676_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017517451982502160950000017673148520456464043_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109007674902459413360000006995944203201471676_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116921622616287307960000017742892385666797501_",
    d: "M82.8,100.5H67.1c-0.7,0-1.3-0.4-1.6-0.9 c-0.3-0.6-0.3-1.3,0-1.9s1-0.9,1.6-0.9h15.8c0.7,0,1.3,0.4,1.6,0.9c0.3,0.6,0.3,1.3,0,1.9C84.1,100.1,83.5,100.5,82.8,100.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017512186884458040850000013143501274189213577_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116921622616287307960000017742892385666797501_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000017512186884458040850000013143501274189213577_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008150163554046178480000005954665262321318295_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173849138203112890380000005033359241598239903_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008150163554046178480000005954665262321318295_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 95.7,
    style: {
      clipPath: "url(#SVGID_00000173849138203112890380000005033359241598239903_)",
      fill: "#55BBB1"
    },
    width: 21.7,
    height: 5.8
  })))))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114047617609785358950000006618834136927247513_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140696040968725004390000000409947336661490859_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114047617609785358950000006618834136927247513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140696040968725004390000000409947336661490859_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044137982363389481220000015517844420354881718_",
    d: "M86.4,70.7c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3c0-3.4-1.8-6.6-4.8-8.3s-6.6-1.7-9.5,0c-3,1.7-4.8,4.9-4.8,8.3c0,0.7-0.4,1.3-0.9,1.6 c-0.6,0.3-1.3,0.3-1.9,0c-0.6-0.3-0.9-1-0.9-1.6c0-4.8,2.5-9.2,6.7-11.5c4.1-2.4,9.2-2.4,13.3,0s6.7,6.8,6.7,11.5 c0,0.5-0.2,1-0.6,1.3C87.4,70.5,86.9,70.7,86.4,70.7L86.4,70.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066516285546302399260000016131397350747282060_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044137982363389481220000015517844420354881718_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066516285546302399260000016131397350747282060_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147936622365328514590000014392620400385047184_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157288910632382518600000015121460473670692770_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147936622365328514590000014392620400385047184_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 53.9,
    style: {
      clipPath: "url(#SVGID_00000157288910632382518600000015121460473670692770_)",
      fill: "#55BBB1"
    },
    width: 28.7,
    height: 17.9
  })))))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116948884693759675370000000635037390438989450_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063634930934697986320000001354491677602462909_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116948884693759675370000000635037390438989450_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000063634930934697986320000001354491677602462909_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133520969585796158100000006702405858637763495_",
    d: "M39,81c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3V59.3c0-0.7,0.4-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.9,0c0.6,0.3,0.9,1,0.9,1.6v19.8c0,0.5-0.2,1-0.6,1.3 C40,80.8,39.5,81,39,81L39,81z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144306588640413963670000006749704100031078305_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133520969585796158100000006702405858637763495_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000144306588640413963670000006749704100031078305_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000139984986312823190020000003858093511568767366_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101804753026193724710000005521309990318288005_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139984986312823190020000003858093511568767366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 56.3,
    style: {
      clipPath: "url(#SVGID_00000101804753026193724710000005521309990318288005_)",
      fill: "#55BBB1"
    },
    width: 5.8,
    height: 25.6
  })))))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152975010966731893040000018324707419607030965_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106853143385785693510000014675422874286947222_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152975010966731893040000018324707419607030965_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106853143385785693510000014675422874286947222_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000120539287534145339560000009257024226099374720_",
    d: "M39,49.7c-1,0-2,0.4-2.7,1.1 c-0.7,0.7-1.1,1.7-1.1,2.7s0.4,2,1.1,2.7s1.7,1.1,2.7,1.1s2-0.4,2.7-1.1c0.7-0.7,1.1-1.7,1.1-2.7s-0.4-2-1.1-2.7 S40,49.7,39,49.7z M39,61.2c-2,0-3.9-0.8-5.3-2.2c-1.4-1.4-2.2-3.3-2.2-5.3s0.8-3.9,2.2-5.4c1.4-1.4,3.3-2.2,5.3-2.3 c2,0,3.9,0.8,5.4,2.2c1.4,1.4,2.3,3.3,2.3,5.3s-0.8,4-2.2,5.4C43,60.4,41,61.2,39,61.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053512842430291516940000010168961849951269550_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120539287534145339560000009257024226099374720_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053512842430291516940000010168961849951269550_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154394558937805775490000001829658783567908017_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110435412843966923140000008686985978210753955_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154394558937805775490000001829658783567908017_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.4,
    y: 45.1,
    style: {
      clipPath: "url(#SVGID_00000110435412843966923140000008686985978210753955_)",
      fill: "#55BBB1"
    },
    width: 17.2,
    height: 17.2
  })))))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000149375107771915885210000001110527563970689207_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074430052702501905830000001009603195283919025_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149375107771915885210000001110527563970689207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074430052702501905830000001009603195283919025_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052826455347027280120000014697644931732662176_",
    d: "M44.5,147.4h60.9V134c0-2.8-1.1-5.4-3.1-7.4 c-2-2-4.6-3.1-7.4-3.1H55c-2.8,0-5.4,1.1-7.4,3.1c-2,2-3.1,4.6-3.1,7.4V147.4z M107.3,151.1H42.6c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3V134c0-3.8,1.5-7.4,4.2-10.1s6.3-4.2,10.1-4.2h39.9c3.8,0,7.4,1.5,10.1,4.2s4.2,6.3,4.2,10.1v15.3 c0,0.5-0.2,1-0.6,1.3C108.3,150.9,107.8,151.1,107.3,151.1L107.3,151.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124842620589562053140000000682366977549027465_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052826455347027280120000014697644931732662176_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124842620589562053140000000682366977549027465_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000006700086695564478940000002794232068188082563_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097466261687905641340000012723916950364275363_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006700086695564478940000002794232068188082563_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 118.7,
    style: {
      clipPath: "url(#SVGID_00000097466261687905641340000012723916950364275363_)",
      fill: "#55BBB1"
    },
    width: 70.4,
    height: 33.4
  })))))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000042730841173436943500000003696142730957575594_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026842400622030403940000011669529598437342083_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042730841173436943500000003696142730957575594_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026842400622030403940000011669529598437342083_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090253182215423687000000005991987479412021668_",
    d: "M65.3,123.5c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-12c0-0.7,0.4-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.9,0s0.9,1,0.9,1.6v12c0,0.5-0.2,1-0.6,1.3 C66.3,123.3,65.8,123.5,65.3,123.5L65.3,123.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074402538110930348880000010777560403203186845_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090253182215423687000000005991987479412021668_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074402538110930348880000010777560403203186845_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000164503560187879872400000006831445865255446669_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133500110206316154160000011849468189300209801_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164503560187879872400000006831445865255446669_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 106.6,
    style: {
      clipPath: "url(#SVGID_00000133500110206316154160000011849468189300209801_)",
      fill: "#55BBB1"
    },
    width: 5.8,
    height: 17.9
  })))))), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000022549719931110755300000012451903159354906777_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111157321923190252470000016986921290353389976_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022549719931110755300000012451903159354906777_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111157321923190252470000016986921290353389976_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075845258301695643170000000659128914935012015_",
    d: "M84.6,123.5c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-12c0-0.7,0.4-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.9,0s0.9,1,0.9,1.6v12c0,0.5-0.2,1-0.6,1.3 C85.6,123.3,85.1,123.5,84.6,123.5L84.6,123.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178165385478756520710000002399111923338973883_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075845258301695643170000000659128914935012015_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178165385478756520710000002399111923338973883_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000020357745599966204450000011054644327974265232_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040569095134235217890000006522350911456466849_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020357745599966204450000011054644327974265232_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 106.6,
    style: {
      clipPath: "url(#SVGID_00000040569095134235217890000006522350911456466849_)",
      fill: "#55BBB1"
    },
    width: 5.8,
    height: 17.9
  })))))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002351625264760200310000002229883240835814033_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181776003029397595940000010824297738616926352_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002351625264760200310000002229883240835814033_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181776003029397595940000010824297738616926352_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000043449591998334131080000013248586426459547051_",
    d: "M60.8,147.4h28.4v-9.2H60.8V147.4z M91.1,151.1H58.9 c-0.5,0-1-0.2-1.3-0.6c-0.4-0.4-0.6-0.8-0.6-1.3v-13c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6h32.2c0.5,0,1,0.2,1.3,0.6 c0.4,0.4,0.6,0.8,0.6,1.3v13c0,0.5-0.2,1-0.6,1.3C92.1,150.9,91.6,151.1,91.1,151.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057843656269141972680000007550524842196799874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043449591998334131080000013248586426459547051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057843656269141972680000007550524842196799874_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000050650061031941254300000003525854842099874210_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117642882160267814470000008136758705757975721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050650061031941254300000003525854842099874210_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 133.3,
    style: {
      clipPath: "url(#SVGID_00000117642882160267814470000008136758705757975721_)",
      fill: "#55BBB1"
    },
    width: 38,
    height: 18.8
  })))))), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000040549497875564353080000012123364124892854962_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041277061861756655570000017297790683248149694_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040549497875564353080000012123364124892854962_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041277061861756655570000017297790683248149694_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000156566968228357875540000015252147730519842998_",
    d: "M127.4,55l-0.1,6.8l11.2,0.1l0.1-6.8V55h-0.1H127.4z  M138.5,65.7h-11.1c-1,0-2-0.4-2.7-1.1c-0.7-0.7-1.1-1.7-1.1-2.8v-6.7c0-1,0.4-2,1.1-2.8c0.7-0.7,1.7-1.1,2.8-1.1h11.1l0,0 c1,0,2,0.4,2.8,1.1c0.7,0.7,1.1,1.7,1.1,2.8v6.7c0,1-0.4,2-1.2,2.8C140.6,65.3,139.6,65.7,138.5,65.7L138.5,65.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129186516175357239130000000725772988083874223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156566968228357875540000015252147730519842998_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129186516175357239130000000725772988083874223_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000118359064211431415410000014057365588993769122_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104702389084788838320000004162992673571229114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118359064211431415410000014057365588993769122_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 50.2,
    style: {
      clipPath: "url(#SVGID_00000104702389084788838320000004162992673571229114_)",
      fill: "#55BBB1"
    },
    width: 20.9,
    height: 16.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178911740522810632670000010943273662830829989_",
    x: 29.8,
    y: 26.1,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163781108351093217730000008629505861859952574_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178911740522810632670000010943273662830829989_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163781108351093217730000008629505861859952574_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000017508560657755874990000004507008172515409567_",
    d: "M137.8,55c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-3.7c0-1-0.6-2-1.5-2.5c-0.9-0.5-2-0.5-2.9,0s-1.5,1.5-1.5,2.5v3.7c0,0.7-0.4,1.3-0.9,1.6 c-0.6,0.3-1.3,0.3-1.9,0s-0.9-1-0.9-1.6v-3.7c0-2.4,1.3-4.6,3.4-5.8c2.1-1.2,4.6-1.2,6.7,0s3.4,3.4,3.4,5.8v3.7 c0,0.5-0.2,1-0.6,1.3C138.8,54.8,138.3,55,137.8,55z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105408941503308633980000000070388334286342785_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017508560657755874990000004507008172515409567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105408941503308633980000000070388334286342785_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047770759207310166160000004963492709707794619_",
    x: 13.8,
    y: 9.1,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031900361983992361180000014680383920490757777_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047770759207310166160000004963492709707794619_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.3,
    y: 41.4,
    style: {
      clipPath: "url(#SVGID_00000031900361983992361180000014680383920490757777_)",
      fill: "#55BBB1"
    },
    width: 15.4,
    height: 14.7
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundRobot);
export default __webpack_public_path__ + "static/media/not-found-robot.26a140e5d58bd68c515cb7064cce0295.svg";
export { ForwardRef as ReactComponent };